import { styled } from "styled-components";

export const BackgroundImageBase = styled.div(({ theme }) => {
  return {
    height: 200,
    width: 248,
    backgroundColor: theme.colors.grayLight,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
  };
});

export interface BackgroundImageProps
  extends React.ComponentProps<typeof BackgroundImageBase> {
  /**  A URL for the image to render */
  image: string | null;
}

/** An image rendered as the `background-image` of a `<div>`.
 *
 * If no image is provided, this component will render `null`.
 */
export const Component: React.FC<BackgroundImageProps> = ({
  image,
  ...props
}) =>
  image ? (
    <BackgroundImageBase
      {...props}
      style={{ backgroundImage: `url('${image}')` }}
    />
  ) : null;

/** An image rendered as the `background-image` of a `<div>`.
 *
 * If no image is provided, this component will render `null`.
 */
export const BackgroundImage = Object.assign(Component, {
  Base: BackgroundImageBase,
});
